import { render, staticRenderFns } from "./ProductViewerKnowledgeCases.vue?vue&type=template&id=36f8daa0&scoped=true&"
import script from "./ProductViewerKnowledgeCases.vue?vue&type=script&lang=js&"
export * from "./ProductViewerKnowledgeCases.vue?vue&type=script&lang=js&"
import style0 from "./ProductViewerKnowledgeCases.vue?vue&type=style&index=0&id=36f8daa0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f8daa0",
  null
  
)

export default component.exports